import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import * as firebase from "firebase/app";
import "firebase/firestore";
import * as _ from "lodash";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { Purchase } from "../models/purchase.model";

import "firebase/firestore";
import { AngularFireFunctions } from "@angular/fire/functions";

@Injectable({
  providedIn: "root",
})
export class PurchaseService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<Purchase>;

  constructor(
    private db: AngularFirestore,
    private userStore: UserService,
    private fns: AngularFireFunctions
  ) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getPurchases(
    shopId: string,
    fromDate: Date,
    toDate: Date
  ): AngularFirestoreCollection<Purchase> {
    return this.db.collection(this.dbPath + `/${shopId}/purchases`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("issueDate", ">=", fromDate)
        .where("issueDate", "<=", toDate)
        .orderBy("issueDate", "desc")
    );
  }

  getPurchaseTradesBySupplier(
    shopId: string,
    supplierId: string,
    fromDate: Date,
    toDate: Date
  ): AngularFirestoreCollection<Purchase> {
    return this.db.collection(this.dbPath + `/${shopId}/purchases`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("isClosed", "==", true)
        .where("supplierId", "==", supplierId)
        .where("issueDate", ">=", fromDate)
        .where("issueDate", "<=", toDate)
        .orderBy("issueDate", "desc")
    );
  }

  getPurchasesByIssueDate(
    shopId: string,
    type: string,
    issueDate: Date
  ): AngularFirestoreCollection<Purchase> {
    return this.db.collection(this.dbPath + `/${shopId}/purchases`, (ref) => {
      let query: CollectionReference | Query = ref;
      let year = issueDate.getFullYear();
      let month = issueDate.getMonth() + 1;
      let day = issueDate.getDate();
      console.log(`getPurchasesByIssueDate: ${day}/${month}/${year}`);

      query = query.where("isDeleted", "==", false);
      query = query.where("isActive", "==", true);
      query = query.where("issueDateYear", "==", year);
      query = query.where("issueDateMonth", "==", month);

      if (type === "day") {
        query = query.where("issueDateDay", "==", day);
      }

      query = query.orderBy("issueDate", "desc");

      return query;
    });
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/purchases`)
      .doc(id)
      .valueChanges();
  }

  getPurchase(shopId: string, id: string) {
    var db = firebase.default.firestore();
    var ref = db.collection(this.dbPath + `/${shopId}/purchases`).doc(id);

    return ref.get();
  }

  create(purchase: Purchase): any {
    let obj = _.clone(purchase);
    delete obj.id;
    obj.purchaseDetails =
      purchase.purchaseDetails.length > 0
        ? JSON.parse(JSON.stringify(purchase.purchaseDetails))
        : [];

    obj.isActive = true;
    obj.isDeleted = false;
    obj.createdOn = new Date();
    obj.createdBy = this.userLogin.uid;
    obj.updatedOn = new Date();
    obj.updatedBy = this.userLogin.uid;
    obj.author = this.userLogin;
    obj.visibility = this.visibility;
    obj.timestamp = new Date().getTime();

    obj.shopId = obj.shopId ? obj.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(
      this.dbPath + `/${purchase.shopId}/purchases`
    );

    console.log("create purchase:", obj);

    return this.collRef.add({ ...obj }).then((docRef) => {
      purchase.id = docRef.id;
      purchase.author = this.userLogin;
      return purchase;
    });
  }

  update(purchase: Purchase): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${purchase.shopId}/purchases`
    );

    console.log("update purchase:", purchase);
    // return this.collRef.doc(purchase.id).update(JSON.parse(JSON.stringify(obj)));
    return this.collRef.doc(purchase.id).update({
      issueDate: purchase.issueDate,
      issueDateSeconds: purchase.issueDateSeconds,
      issueDateMinutes: purchase.issueDateMinutes,
      issueDateHours: purchase.issueDateHours,
      issueDateDay: purchase.issueDateDay,
      issueDateWeekDay: purchase.issueDateWeekDay,
      issueDateMonth: purchase.issueDateMonth,
      issueDateYear: purchase.issueDateYear,
      code: purchase.code ? purchase.code : "",
      note: purchase.note ? purchase.note : "",
      tags: purchase.tags ? purchase.tags : [],
      status: purchase.status,

      supplierId: purchase.supplierId ? purchase.supplierId : "",
      supplierName: purchase.supplierName ? purchase.supplierName : "",
      supplierMobile: purchase.supplierMobile ? purchase.supplierMobile : "",
      supplierAddress: purchase.supplierAddress ? purchase.supplierAddress : "",

      totalDiscountAmount: purchase.totalDiscountAmount,
      detailDiscountAmount: purchase.detailDiscountAmount,
      discountAmount: purchase.discountAmount,
      discountPercent: purchase.discountPercent,
      detailAmount: purchase.detailAmount,
      detailNetAmount: purchase.detailNetAmount,
      totalQuantity: purchase.totalQuantity,
      totalAmount: purchase.totalAmount,
      vatPercent: purchase.vatPercent,
      vatAmount: purchase.vatAmount,
      isCancel: purchase.isCancel,
      isClosed: purchase.isClosed,
      isPrint: purchase.isPrint,
      noPrint: purchase.noPrint,

      isDebit: !!purchase.isDebit,
      isCash: purchase.isCash,
      paymentAmount: purchase.paymentAmount,
      paymentRefund: purchase.paymentRefund,
      purchaseDetails:
        purchase.purchaseDetails.length > 0
          ? JSON.parse(JSON.stringify(purchase.purchaseDetails))
          : [],

      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  unlock(shopId: string, id: string) {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/purchases`);
    return this.collRef.doc(id).update({
      isClosed: false,
      status: "Mở lại phiếu",
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  delete(shopId: string, id: string) {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/purchases`);
    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }
}
